module.exports = __webpack_public_path__ + "static/img/instagram.0b6b3c8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/floating-button/instagram.png
// module id = lXjd
// module chunks = 48